export default [
    {
        name: "Alex Andrews",
        title: "Technical Program Manager",
        team: "Customer experience",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/pub/alexander-andrews/90/4b5/308"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Alex.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Alexbw.jpg"
    },
    /*{
        name: "Amanda Repansky",
        team: "",
        networks: [],
        imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
    },*/
    {
        name: "Amos Schallich",
        title: "VP of Engineering",
        team: "VP of Engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/schallich"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Amos.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Amosbw.jpg",
        sticky: true
    },
    {
        name: "Andres Cassinelli",
        title: "Hardware Engineer",
        team: "Hardware engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/andrescassinelli"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Andres.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Andresbw.jpg"
    },
    {
        name: "Andrew Bleich",
        team: "Manufacturing operations & supply chain",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/andrewbleich"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Andrew.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Andrewbw.jpg"
    },
    /*{
     name: "Athena Draper",
     team: "",
     networks: [],
     imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
     },*/
    {
        name: "Austin Lin",
        title: "Product Manager",
        team: "Product",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/austinklin"
            },
            {
                icon: "eo-icon-twitter",
                url: "https://twitter.com/austinlin"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Austin.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Austinbw.jpg"
    },
    {
        name: "Brandon Meixel",
        team: "IT Lead",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/meixellent"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Brandon.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Brandonbw.jpg"
    },
    {
        name: "Brendan Freund",
        team: "Hardware engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/pub/brendan-freund/8b/80b/b5b"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Brendan.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Brendanbw.jpg"
    },
    {
        name: "Calvin Feng",
        team: "Manufacturing operations & supply chain",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/calvin-feng-4200545?trk=hp-identity-name"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Calvin.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Calvinbw.jpg"
    },
    {
        name: "Chris Johnson",
        team: "Software engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/chris-johnson-9064158"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Chris.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Chrisbw.jpg"
    },
    /*{
     name: "Christine Wang",
     team: "",
     networks: [],
     imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
     },*/
    /*{
     name: "Christoph Moskalonek",
     team: "",
     networks: [],
     imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
     },*/
    /*{
     name: "Cliff Clarke",
     team: "",
     networks: [],
     imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
     },*/
    /*{
        name: "Dana Lindsay",
        team: "Customer Experience",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/dana-lindsay-04051461?trk=hp-identity-name"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
    },*/
    {
        name: "David Spiegelman",
        title: "QA - Network Test",
        team: "Quality assurance",
        networks: [],
        imgUrl: "/public/img/our-story/employees/img-David.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Davidbw.jpg"
    },
    /*{
     name: "Derrick Lam",
     team: "",
     networks: [],
     imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
     },*/
    {
        name: "Drew Dickson",
        title: "DevOps Engineer",
        team: "Software engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/thelinuxguy"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Drew.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Drewbw.jpg"
    },
    /*{
        name: "Fan Yang",
        title: "WiFi Engineer",
        team: "Hardware engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "http://www.linkedin.com/in/fandaman"
            },
            {
                icon: "eo-icon-twitter",
                url: "http://twitter.com/yeckfam"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
    },*/
    {
        name: "Gabe Kassel",
        title: "Software Program Manager",
        team: "Product",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/gabekassel"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Gabe.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Gabebw.jpg"
    },
    /*{
     name: "Geoffrey Smith",
     team: "",
     networks: [],
     imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
     },*/
    {
        name: "George Liu",
        team: "Business operations",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/george-liu-6206044"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-George.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Georgebw.jpg"
    },
    /*{
        name: "Grant Oladipo",
        title: "Mobile Engineering Lead",
        team: "",
        networks: [],
        imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
    },*/
    /*{
        name: "Jas Strong",
        title: "Embedded Systems Engineer",
        team: "",
        networks: [],
        imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
    },*/
    {
        name: "Jason Karsh",
        title: "Marketing Generalist",
        team: "Marketing",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/jakarsh"
            },
            {
                icon: "eo-icon-twitter",
                url: "https://twitter.com/jasonkarsh"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Jason.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Jasonbw.jpg"
    },
    {
        name: "Jatin Grover",
        title: "Hardware Test Engineer",
        team: "Hardware engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/pub/jatin-grover/7/aa0/163"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Jatin.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Jatinbw.jpg"
    },
    {
        name: "Jay Kruse",
        title: "Head of RF Engineering",
        team: "Hardware engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/jay-kruse-6baa473"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Jay.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Jaybw.jpg"
    },
    {
        name: "Jelena Weinstein",
        title: "Recruiting Coordinator",
        team: "Talent & recruiting",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/pub/jelena-weinstein/59/183/748"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Jelena.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Jelenabw.jpg"
    },
    {
        name: "Jess Chen",
        title: "Designer",
        team: "Design",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/pub/jessica-chen/22/8ab/a7a"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Jess.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Jessbw.jpg"
    },
    {
        name: "Joe Cheung",
        title: "Talent Manager",
        team: "Talent & recruiting",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/jcheung"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Joe.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Joebw.jpg"
    },
    {
        name: "John Breidenbach",
        team: "Hardware engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/johntb"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-JohnB.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-JohnBbw.jpg"
    },
    {
        name: "John Loomis",
        title: "Head of Manufacturing",
        team: "Manufacturing operations & supply chain",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/pub/john-loomis/1/b94/50b"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-JohnLoomis.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-JohnLoomisbw.jpg"
    },
    {
        name: "John Lynn",
        title: "Software Engineer",
        team: "Software engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/johnlynn1"
            },
            {
                icon: "eo-icon-twitter",
                url: "http://twitter.com/johnlynn1"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-JohnLynn.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-JohnLynnbw.jpg"
    },
    {
        name: "Jon Araquistain",
        title: "Software Engineer",
        team: "Software engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/araquistain"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Jon.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Jonbw.jpg"
    },
    {
        name: "Jordan Jozwiak",
        team: "Mobile engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/jordan-jozwiak-77a9a770"
            },
            {
                icon: "eo-icon-twitter",
                url: "https://twitter.com/jordanjoz"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Jordan.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Jordanbw.jpg"
    },
    /*{
     name: "Josh Johnson",
     team: "",
     networks: [],
     imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
     },*/
    /*{
     name: "Jules Naujoks",
     team: "",
     networks: [],
     imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
     },*/
    {
        name: "Junie Yee",
        team: "Customer experience",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "http://www.linkedin.com/in/junieyee"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Junie.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Juniebw.jpg"
    },
    /*{
        name: "Justin Chien",
        title: "Operations Manager",
        team: "Manufacturing operations & supply chain",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/pub/justin-chien/9/b0a/18b"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
    },*/
    /*{
         name: "Justin Shultz",
         team: "",
         networks: [],
         imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
     },*/
    /*{
        name: "Karim Khaldi",
        title: "Test Engineer",
        team: "",
        networks: [],
        imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
    },*/
    {
        name: "Katharine Matsumoto",
        title: "Data Scientist",
        team: "Product",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/katharinematsumoto"
            },
            {
                icon: "eo-icon-twitter",
                url: "https://twitter.com/kmmats"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Katharine.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Katharinebw.jpg"
    },
    {
        name: "Kathleen Lee",
        title: "Designer",
        team: "Design",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/kelee"
            },
            {
                icon: "eo-icon-twitter",
                url: "https://twitter.com/kathleenelee"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Kathleen.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Kathleenbw.jpg"
    },
    {
        name: "Kelly Neary",
        team: "Business operations",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/kellymarieneary"
            },
            {
                icon: "eo-icon-twitter",
                url: "https://twitter.com/kmneary"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Kelly.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Kellybw.jpg"
    },
    /*{
        name: "Lorraine Lucia",
        team: "",
        networks: [],
        imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
    },*/
    {
        name: "Luke Lum",
        team: "Hardware engineering",
        networks: [
            {
                icon: "eo-icon-linkedine",
                url: "https://www.linkedin.com/in/lukelum"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Luke.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Lukebw.jpg"
    },
    /*{
        name: "Luke",
        team: "K9 Unit",
        networks: [],
        imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Lukedogbw.jpg"
    },*/
    {
        name: "Mar Snider",
        title: "Marketing Associate",
        team: "Marketing",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/margaretsnider"
            },
            {
                icon: "eo-icon-twitter",
                url: "https://twitter.com/marsnider213"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Mar.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Marbw.jpg"
    },
    /*{
     name: "Marina Valner",
     team: "",
     networks: [],
     imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
     },*/
    {
        name: "Mark Sieglock",
        title: "Business Operations",
        team: "Business operations",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/pub/mark-sieglock/25/222/133"
            },
            {
                icon: "eo-icon-twitter",
                url: "https://twitter.com/marksieglock"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Mark.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Markbw.jpg"
    },
    /*{
     name: "Matt Latham",
     team: "",
     networks: [],
     imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
     },*/
    /*{
     name: "Mete Rodoper",
     team: "Software engineering",
     networks: [
        {
            icon: "eo-icon-linkedin",
            url: "https://www.linkedin.com/in/mrodoper"
        }
     ],
     imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
     },*/
    /*{
     name: "Mike Mintz",
     team: "",
     networks: [],
     imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
     },*/
    {
        name: "Natalie Pau",
        team: "Talent & recruiting",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "http://www.linkedin.com/in/nataliegpau"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Natalie.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Nataliebw.jpg"
    },
    {
        name: "Nate Hardison",
        title: "CTO",
        team: "CTO",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/natehardison"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Nate2.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Nate2bw.jpg",
        sticky: true
    },
    {
        name: "Nick Weaver",
        title: "CEO",
        team: "CEO",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/nsweaver"
            },
            {
                icon: "eo-icon-twitter",
                url: "https://twitter.com/nsweaves"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Nick.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Nickbw.jpg",
        sticky: true
    },
    {
        name: "Olivier Adler",
        title: "Head of Finance",
        team: "Business Operations",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "http://www.linkedin.com/in/olivieradler"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Ollie.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Olliebw.jpg"
    },
    {
        name: "Paul Nangeroni",
        title: "Head of Product",
        team: "Product",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/pub/paul-nangeroni/3/70b/b74"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Paul.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Paulbw.jpg"
    },
    /*{
        name: "Paul Collier",
        team: "Mobile engineering",
        networks: [
            {
                icon: "eo-icon-twitter",
                url: "http://twitter.com/pshc"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
    },*/
    {
        name: "Phil Moon",
        team: "Business operations",
        networks: [],
        imgUrl: "/public/img/our-story/employees/img-Phil.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Philbw.jpg"
    },
    {
        name: "Qiong Wu",
        title: "Software Engineer",
        team: "Software engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/qiongw"
            },
            {
                icon: "eo-icon-twitter",
                url: "https://twitter.com/creasywuqiong"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Q.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Qbw.jpg"
    },
    /*{
     name: "Rick Strong",
     team: "",
     networks: [],
     imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
     },*/
    {
        name: "Rob Ashe",
        title: "Creative Director",
        team: "Design",
        networks: [
            {
                icon: "eo-icon-twitter",
                url: "https://twitter.com/rbashe"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Rob.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Robbw.jpg"
    },
    {
        name: "Rowan Chakoumakos",
        title: "Software Engineer",
        team: "Software engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/rowanchakoumakos"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Rowan.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Rowanbw.jpg"
    },
    {
        name: "Ryan Thompson",
        title: "Software Engineer",
        team: "Software engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/ryan3thompson"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Ryan.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Ryanbw.jpg"
    },
    {
        name: "Scott Wagoner",
        title: "Business Operations",
        team: "Business operations",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/wagoners"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Scott.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Scottbw.jpg"
    },
    {
        name: "Sean Harris",
        title: "Head of Marketing",
        team: "Marketing",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/mrseanharris"
            },
            {
                icon: "eo-icon-twitter",
                url: "https://twitter.com/mrseanharris"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Sean.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Seanbw.jpg"
    },
    {
        name: "Smriti Rangan",
        team: "Quality assurance",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/smritirangan"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Smriti.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Smritibw.jpg"
    },
    /*{
        name: "Sprocket Cheung",
        team: "K9 Unit",
        networks: [
            {
                icon: "eo-icon-instagram",
                url: "https://www.instagram.com/sprockies/"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
    },*/
    {
        name: "Srikanth Kondragunta",
        team: "Manufacturing operations & supply chain",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/srikondragunta"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Srikanth.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Srikanthbw.jpg"
    },
    {
        name: "Stellios Leventis",
        title: "Firmware Engineer",
        team: "Software engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/stelliosleventis"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Stellios.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Stelliosbw.jpg"
    },
    {
        name: "Tyler Newman",
        title: "QA Manager",
        team: "Quality assurance",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/tylernewman"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Tyler.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Tylerbw.jpg"
    },
    /*{
        name: "Victoria Lerch",
        team: "",
        networks: [],
        imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
    },*/
    {
        name: "Vikas Yendluri",
        title: "Software Engineer",
        team: "Software engineering",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/vikasuy"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Vikas.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Vikasbw.jpg"
    },
    /*{
        name: "Yanick Alder",
        team: "Manufacturing operations & supply chain",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/yanick-alder-37796a22"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Lukedog.jpg"
    },*/
    {
        name: "Zoz Cuccias",
        team: "Communications",
        networks: [
            {
                icon: "eo-icon-linkedin",
                url: "https://www.linkedin.com/in/zoz-cuccias-72637415?trk=nav_responsive_tab_profile"
            },
            {
                icon: "eo-icon-twitter",
                url: "https://twitter.com/ZozCuccias"
            }
        ],
        imgUrl: "/public/img/our-story/employees/img-Zoz.jpg",
        bwUrl: "/public/img/our-story/employees/BW/img-Zozbw.jpg"
    },
];



/** WEBPACK FOOTER **
 ** ./app/utils/constants/employees.js
 **/